'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defaults2 = require('lodash/defaults');

var _defaults3 = _interopRequireDefault(_defaults2);

var _sortBy2 = require('lodash/sortBy');

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

exports.default = sort;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sort(props, options) {
    var _ref = options || {},
        direction = _ref.direction;

    direction = (0, _isString3.default)(direction) ? direction.trim().toLowerCase() : 'asc';

    var series = props.series,
        seriesNormalized = props.seriesNormalized,
        maxX = props.maxX,
        maxY = props.maxY,
        minX = props.minX,
        minY = props.minY;


    series = (0, _map3.default)(series, function (series) {

        var newSeries = {};

        newSeries.data = (0, _sortBy3.default)(series.data, 'y');

        if (direction === 'desc') {
            newSeries.data.reverse();
        }

        newSeries.data = (0, _map3.default)(newSeries.data, function (point, pointIndex) {
            var newPoint = {
                realX: point.x,
                x: pointIndex
            };
            return (0, _defaults3.default)(newPoint, point);
        });

        newSeries.data = (0, _sortBy3.default)(newSeries.data, 'realX');

        return (0, _defaults3.default)(newSeries, series);
    });

    return {
        series: series, seriesNormalized: seriesNormalized,
        maxX: maxX, maxY: maxY, minX: minX, minY: minY
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/rumble-charts/lib/helpers/transforms/sort.js
 ** module id = 1562
 ** module chunks = 3
 **/